import {match} from 'ts-pattern';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {BankAccountDomain} from '@dms/api/base';
import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

import {getBankAccountDomainLabel} from './getBankAccountDomainLabel';

/**
 * Chip labels shown on a collapsed bank-account card:
 * - assigned domains -> one label per domain
 * - no assignment, but assignment is relevant (multi-domain tenant) -> a single "All" label
 * - no assignment in a single-domain tenant -> no chips (the domain scope is meaningless)
 */
export function getBankAccountDomainFlagLabels(
  domains: BankAccountDomain[] | Nullish,
  isDomainAssignmentEnabled: boolean
): string[] {
  const assignedDomains = domains ?? [];

  return match({
    hasAssignedDomains: isNotNilOrEmpty(assignedDomains),
    isDomainAssignmentEnabled,
  })
    .with({hasAssignedDomains: true}, () => assignedDomains.map(getBankAccountDomainLabel))
    .with({isDomainAssignmentEnabled: true}, () => [i18n.t('entity.bank.labels.allDomains')])
    .otherwise(() => []);
}
